import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { DataWidgetComponent } from './data-widget.component';
import { MobileAppPtiRanking } from '../models/mobileAppPtiRanking';

@Component({
  template: ` <ng-container *ngIf="value > 0.01; else lesspercent">
      <span>{{ value | pxpercent: format || '1.2' }}</span>
    </ng-container>
    <ng-template #lesspercent>
      <ng-container *ngIf="value > 0; else zeropercent"> < 1% </ng-container>
    </ng-template>
    <ng-template #zeropercent>0%</ng-template>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PercentDataWithZeroComponent
  extends DataWidgetComponent
  implements OnInit
{
  @Input()
  data: MobileAppPtiRanking;

  value;

  ngOnInit(): void {
    super.ngOnInit();

    this.value = this.data[this.key];
  }
}
